/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {CoreUser} from "@mm-products/java-multima-framework";
import type {TaxLicenceDto} from "./TaxLicenceDto";
import type {TaxSystemIntegrationDto} from "./TaxSystemIntegrationDto";

export type TaxAccountantDto = {
    readonly _permissions?: Array<string>;
    created?: string;
    creator?: string;
    creatorId?: string;
    id?: string;
    licence?: TaxLicenceDto;
    licenceAdmin?: boolean;
    onboardingRequired?: boolean;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    softwareName?: TaxAccountantDto.softwareName;
    softwarePath?: string;
    taxSystemIntegration?: TaxSystemIntegrationDto;
    unitsPath?: string;
    user?: CoreUser;
    valid?: boolean;
};

export namespace TaxAccountantDto {
    export enum softwareName {
        POHODA = "POHODA",
        POHODA_SQL = "POHODA_SQL",
        FLEXIBEE = "FLEXIBEE",
        MONEYS3 = "MONEYS3",
        MONEYS3_API = "MONEYS3_API",
        ISDOC = "ISDOC",
        OTHER = "OTHER",
    }
}
